import { Div, Icon, lightTheme } from '../../styles';
import { GreenCheckMark, XIcon } from '../../assets';
import { ButtonProps, ButtonStyled } from './button.styled';
import { ButtonSpinner } from './buttonSpinner';
import { TooltipIcon } from '@vgrubs/components';

export function Button({
  children,
  ...props
}: {
  children: React.ReactNode;
} & ButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <ButtonStyled type="button" {...props}>
      <span>{children}</span>
      {props.$tooltip && (
        <Div
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          style={{ zIndex: 99999, marginRight: '-4px' }}
        >
          <TooltipIcon
            tooltip={props.$tooltip}
            p="4px"
            color={lightTheme.white}
          />
        </Div>
      )}
      {props.$loading && <ButtonSpinner color={props.$loadingColor} />}
      {props.$success && (
        <Div $right="10px" $top="50%" $transform="translateY(-50%)" $absolute>
          <Icon $size={24} color={lightTheme.white}>
            <GreenCheckMark />
          </Icon>
        </Div>
      )}
      {props.$xButton && (
        <Div $right="10px" $top="50%" $transform="translateY(-50%)" $absolute>
          <Icon
            $size={24}
            color={lightTheme.white}
            onClick={(e: React.MouseEvent<HTMLDivElement>) => {
              e.preventDefault();
              e.stopPropagation();
              props.onXButtonClick?.(e);
            }}
          >
            <XIcon />
          </Icon>
        </Div>
      )}
    </ButtonStyled>
  );
}
